var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCategories(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,11.4H3.7c-1.1,0-2-0.9-2-2V3.7c0-1.1,0.9-2,2-2h5.7c1.1,0,2,0.9,2,2v5.7C11.4,10.5,10.5,11.4,9.4,11.4z  M3.7,3.7v5.7h5.7l0-5.7H3.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.3,11.4h-5.7c-1.1,0-2-0.9-2-2V3.7c0-1.1,0.9-2,2-2h5.7c1.1,0,2,0.9,2,2v5.7 C22.3,10.5,21.4,11.4,20.3,11.4z M14.6,3.7v5.7h5.7l0-5.7H14.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,22.3H3.7c-1.1,0-2-0.9-2-2v-5.7c0-1.1,0.9-2,2-2h5.7c1.1,0,2,0.9,2,2v5.7C11.4,21.4,10.5,22.3,9.4,22.3z  M3.7,14.6v5.7h5.7l0-5.7H3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.3,22.3h-5.7c-1.1,0-2-0.9-2-2v-5.7c0-1.1,0.9-2,2-2h5.7c1.1,0,2,0.9,2,2v5.7 C22.3,21.4,21.4,22.3,20.3,22.3z M20.3,20.3v1V20.3L20.3,20.3z M14.6,14.6v5.7h5.7l0-5.7H14.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategories);
export default __webpack_public_path__ + "static/media/icon-categories.f5775fbdbdc691aec3d4c6122e7dda67.svg";
export { ForwardRef as ReactComponent };